import { DocPage } from "../components/DocPage";

export const ssr = { mode: "ssg" as const };

export default function GettingStarted() {
  return (
    <DocPage
      title="Getting started — Landrr.js"
      description="Create and run a new Landrr.js app."
    >
      <h1>Getting started</h1>
      <p>Create a new app in one command:</p>
      <pre>
        <code>{`npx create-landrr-app my-app
cd my-app
npm run dev`}</code>
      </pre>
      <p>Open <code>http://localhost:3000</code>.</p>
      <h2>Project layout</h2>
      <ul>
        <li><code>server.js</code> — Landrr SSR server</li>
        <li><code>src/entry-server.tsx</code> — SSR render entry</li>
        <li><code>src/entry-client.tsx</code> — client hydration</li>
        <li><code>src/pages/</code> — route modules</li>
      </ul>
    </DocPage>
  );
}
